import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b104edec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Duplicate Contacts")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "top-sub-heading"
}
const _hoisted_3 = {
  key: 1,
  class: "top-sub-heading"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Would you like to modify one of existing Contacts below, or continue adding a New Contact?", -1))

import { PropType, computed, ref } from 'vue';
import { DuplicateContact } from '@/types/contacts/DuplicateContact';
import modalBase from '@/components/ui/modals/modal-base.vue';
import { ModalWidth } from '@/types/ui/modals/ModalWidth';
import gridBase from '@/components/ui/grid/grid-base.vue';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxColumn } from "devextreme-vue/data-grid";


export default /*#__PURE__*/_defineComponent({
  __name: 'duplicate-contact-modal',
  props: {
    /** 
     * The boolean value used with `v-model` to control the visibility or state of a modal or component.
     * @type {boolean}
     * @required
     */
    modelValue: {
        type: Boolean,
        required: true
    },
    /** 
     * An array of duplicate contact records.
     * @type {DuplicateContact[]}
     * @required
     */
    contacts: {
        type: Array as PropType<DuplicateContact[]>,
        required: true
    },
    /** 
     * The title of the field being displayed.
     * @type {string}
     * @required
     */
    titleField: {
        type: String,
        required: true
    }
},
  emits: [
    /** 
     * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
     * @property {boolean} value - Indicates whether the modal has been opened or closed.
     */
    'update:modelValue', 
    /** 
     * Emitted when a contact is selected, and notifies the parent component.
     * @property {number} id - The unique identifier of the newly created contact.
     */
    'selectContact'
],
  setup(__props, { emit }) {

const props = __props;





const openModal = computed({
    get: () => props.modelValue,
    set: (value: boolean) => emit('update:modelValue', value)
});

const selectedContact = ref<DuplicateContact>();

const updateEditModalWithSelectedDetails = (id: number) => {
    if (id == -1) {
        return
    }
    openModal.value = false;
    selectedContact.value = undefined;
    emit('selectContact', id);
};

const onRowClick = (e: any) => {
    updateEditModalWithSelectedDetails(e.id);
};

const onRowSelected = (e: any) => {
    selectedContact.value = e;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(modalBase, {
    modelValue: openModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((openModal).value = $event)),
    title: "",
    showCloseButton: true,
    width: _unref(ModalWidth).Small,
    height: "25rem"
  }, {
    "main-title": _withCtx(() => [
      _hoisted_1
    ]),
    "sub-title": _withCtx(() => [
      (props.contacts.length > 1)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Contacts have been found with similar " + _toDisplayString(props.titleField) + "s to the Contact you are adding.", 1))
        : _createCommentVNode("", true),
      (props.contacts.length == 1)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " A contact has been found with a similar " + _toDisplayString(props.titleField) + " to the Contact you are adding.", 1))
        : _createCommentVNode("", true),
      _hoisted_4
    ]),
    "non-scrollable-content": _withCtx(() => [
      _createVNode(gridBase, {
        "data-source": props.contacts,
        "id-column-name": "id",
        "show-column-filters": false,
        "show-search-panel": false,
        onRowClick: onRowClick,
        onRowSelected: onRowSelected,
        onAdaptiveRowSelection: onRowSelected
      }, {
        columns: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "name",
            caption: "Name",
            "hiding-priority": 9,
            width: "200px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "address",
            caption: "Address",
            "hiding-priority": 5
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "email",
            caption: "Email",
            "hiding-priority": 7,
            width: "150px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "mobile",
            caption: "Mobile",
            "hiding-priority": 6,
            width: "100px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "type",
            caption: "Type",
            "hiding-priority": 4
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "status",
            caption: "Status",
            "hiding-priority": 3
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "id",
            caption: "ID",
            "hiding-priority": 2
          })
        ]),
        _: 1
      }, 8, ["data-source"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: { text: 'Continue Adding', onClick: () => { openModal.value = false } }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: { text: 'Edit Selected', disabled: !selectedContact.value, onClick: () => updateEditModalWithSelectedDetails(selectedContact.value?.id ?? -1) }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})